import React from 'react';
import { Divider } from 'semantic-ui-react';

import { Column } from 'components/Layout';

export default () => (
  <Column width={16}>
    <Divider fitted style={{ marginLeft: -20, marginRight: -20 }} />
  </Column>
);



// WEBPACK FOOTER //
// ./app/components/Forms/UI/DividerForm/index.js